module.exports = __webpack_public_path__ + "static/media/bg.fd1a1dd6.jpg";